import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import * as ReactDOM from "react-dom";
import { Badge, Card, CardBody, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Nav, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { ModalFooter } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import {
  getPartnerPromotionSettings,
  getVariantProductList,
  partnerProductSearch,
  removeSelectAllForFilter,
  setIsAllActive,
  setPartnerPromotionSettings,
  setProducts,
  setProductVariantIds,
  setSearchProductDialog,
  storeSelectAllForFilter,
} from "../../store/partnerPromotionSlice";
import PreLoader from "../../../../share-components/ui/preLoader";

const marketplaces = [
  { id: 1, name: "Amazon" },
  { id: 2, name: "AliExpress" },
  { id: 3, name: "eBay" },
  { id: 4, name: "Walmart" },
  { id: 5, name: "Etsy" },
  { id: 6, name: "Flipkart" },
  { id: 7, name: "Rakuten" },
  { id: 8, name: "Shopee" },
  { id: 9, name: "Lazada" },
  { id: 10, name: "Newegg" },
];

const PartnerProductsSearchModalWindow = (props) => {
  const { setValue, trigger, getValues, imageSelectOnClick, updatePromotionProducts, isProductUpdate, onTagOrCollectionChange } = props;
  const dispatch = useDispatch();
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.partnerPromotionSetting?.setting);
  const selectedVariantIdsFromStore = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion.selectedProductVariantIds);
  const selectAllIdsByFilter = useSelector((s) => s.partnerPromotion.partnerPromotion.selectAllIdsByFilter);
  const orderState = useSelector(({ order }) => order.draftOrder);
  let variantRef = useRef([]);
  let infiniteScrollRef = useRef();
  const didInitRef = useRef(false);
  const selectAllClickRef = useRef(false);
  const selectAllInputRef = useRef(null);
  const originalVariantIdsRef = useRef([]);
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [checkedIds, setCheckedIds] = useState([]);
  const [collection, setCollection] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [tags, setTags] = useState([]);
  const [isIncludeSaleItem, setIsIncludeSaleItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localSelectedProducts, setLocalSelectedProducts] = useState([]);
  const isTagOrCollectionSelected = Boolean(collection) || (Array.isArray(tags) && tags.length > 0);
  const [currentVariantIds, setCurrentVariantIds] = useState([]);
  const added = currentVariantIds.filter((id) => !originalVariantIdsRef.current.includes(id));

  const removed = originalVariantIdsRef.current.filter((id) => !currentVariantIds.includes(id));

  const filterKey = useMemo(() => {
    return JSON.stringify({
      collection: collection ?? null,
      tags: (tags ?? []).map((t) => t.value).sort(),
      searchTerm: searchTerm ?? "",
      isIncludeSaleItem: isIncludeSaleItem ? 1 : 0,
    });
  }, [collection, tags, searchTerm, isIncludeSaleItem]);

  console.log("loading", loading);

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    onTagOrCollectionChange(isTagOrCollectionSelected);
  }, [isTagOrCollectionSelected]);

  useEffect(() => {
    if (partnerPromotionState.searchProductDialogProps.props.isOpen) {
      setSearchTerm("");
    }
  }, [partnerPromotionState.searchProductDialogProps.props]);

  useEffect(() => {
    if (!partnerPromotionState.searchProductDialogProps.props.isOpen) {
      didInitRef.current = false;
      return;
    }

    if (!didInitRef.current) {
      originalVariantIdsRef.current = selectedVariantIdsFromStore || [];
      setCheckedIds(selectedVariantIdsFromStore || []);
      setCurrentVariantIds(selectedVariantIdsFromStore || []);
      didInitRef.current = true;
    }

    productSearchFunction(false, 1);
  }, [partnerPromotionState.searchProductDialogProps.props, searchValue, searchTerm, collection, tags, isIncludeSaleItem]);

  useEffect(() => {
    if (!productData.length) return;

    const matched = [];

    productData.forEach((product) => {
      product.variants.forEach((variant) => {
        if (currentVariantIds.includes(variant.id)) {
          matched.push({
            id: null,
            variant: variant.id,
            product: product.id,
            product_name: product.name,
            image: product.url,
            price: variant.price,
            sku: variant.sku,
            variant_name: variant.variant_name,
            quantity: 1,
            total_price: variant.price,
            current_stock: variant.current_stock,
            format_stock: variant.format_stock,
            sale_price: variant.sale_price,
            rrp: variant.price,
            cost_price: variant.cost_price,
          });
        }
      });
    });

    setLocalSelectedProducts(matched);
  }, [productData, currentVariantIds]);

  useEffect(() => {
    if (!productData.length) return;

    if (!selectAllClickRef.current) return;

    const visibleVariantIds = productData.flatMap((p) => p.variants.filter((v) => v.price > 0).map((v) => v.id));

    if (selectAll === true) {
      setCheckedIds((prev) => [...new Set([...prev, ...visibleVariantIds])]);

      setCurrentVariantIds((prev) => [...new Set([...prev, ...visibleVariantIds])]);
    } else {
      setCheckedIds((prev) => prev.filter((id) => !visibleVariantIds.includes(id)));

      setCurrentVariantIds((prev) => prev.filter((id) => !visibleVariantIds.includes(id)));

      setLocalSelectedProducts((prev) => prev.filter((item) => !visibleVariantIds.includes(item.variant)));
    }

    selectAllClickRef.current = false;
  }, [selectAll, productData]);

  useEffect(() => {
    if (!productData.length) return;
    const visibleIds = productData.flatMap((p) => p.variants.filter((v) => v.price > 0).map((v) => v.id));

    const visibleChecked = visibleIds.filter((id) => checkedIds.includes(id)).length;
    const allSelected = visibleIds.length > 0 && visibleChecked === visibleIds.length;
    const someSelected = visibleChecked > 0 && !allSelected;

    if (selectAll !== allSelected) setSelectAll(allSelected);
    if (selectAllInputRef.current) {
      selectAllInputRef.current.indeterminate = someSelected;
    }
  }, [checkedIds, productData]);

  const filteredCollectionOptions = allSettings?.collections
    .filter((type) => type.title?.toLowerCase())
    .map((type) => ({
      value: type.id,
      label: type.title,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const partnersPromiseOption = (inputValue, callback) => {
    const filteredOptions = allSettings?.tags
      .filter((type) => type.name.toLowerCase().includes(inputValue.toLowerCase()))
      .map((type) => ({
        value: type.id,
        label: type.name,
      }));
    callback(filteredOptions);
  };

  const closDialog = () => {
    setSearchValue("");
    setLocalSelectedProducts([]);
    setCheckedIds([]);
    setSelectAll(false);
    dispatch(setSearchProductDialog({ props: { isOpen: false } }));
  };

  const getVariantDiff = () => {
    const original = selectedVariantIdsFromStore || [];
    const current = checkedIds || [];

    const added = current.filter((id) => !original.includes(id));
    const removed = original.filter((id) => !current.includes(id));

    return { added, removed };
  };

  const setSelectedProducts = () => {
    setValue("promotion_products_new", localSelectedProducts);
    trigger("promotion_products_new");
    setValue("promotion_products", localSelectedProducts);
    updatePromotionProducts({ added, removed });
    if (!isProductUpdate) {
      closDialog();
    }
  };

  const productSearchFunction = (isConcat, page) => {
    const formatTags = tags.length > 0 && tags.map((item) => item.value).join(",");
    const isTagOrCollectionFilter = Boolean(collection) || (Array.isArray(tags) && tags.length > 0);

    if (searchTerm || collection || tags || isIncludeSaleItem) {
      setLoading(true);
      dispatch(
        getVariantProductList({
          name: searchTerm,
          page: page,
          ...(collection && { collection: collection }),
          ...(tags.length > 0 && { tags: formatTags }),
          is_include_sales_item: isIncludeSaleItem === true ? 1 : 0,
          is_tag_or_collection: isTagOrCollectionFilter ? 1 : 0,
        })
      ).then((res) => {
        if (!res.error) {
          dispatch(setProducts(res.payload));
          const matchedIds = res.payload.all_matched_variant_ids || [];
          if (page === 1) {
            dispatch(setProductVariantIds(matchedIds));
          }
          if (page === 1 && selectAllClickRef.current && selectAll === true) {
            dispatch(storeSelectAllForFilter({ filterKey, ids: matchedIds }));

            setCurrentVariantIds((prev) => [...new Set([...prev, ...matchedIds])]);
            setCheckedIds((prev) => [...new Set([...prev, ...matchedIds])]);
          }

          if (isConcat) {
            setProductData((prevArray) => [...prevArray, ...res.payload.data]);
            setLoading(false);
          } else {
            setProductData(res.payload.data);
            setLoading(false);
          }
        }
      });
    }
  };

  const productOnChange = (e, product, variants) => {
    const isChecked = e.target.checked;
    const ids = variants.filter((v) => v.price > 0).map((v) => v.id);

    let updatedProducts = [...localSelectedProducts];
    let updatedCheckedIds = [...checkedIds];

    variants.map((item, i) => {
      if (item.price > 0) {
        variantRef.current[item.id].checked = e.target.checked;
        updatedProducts = productObjectUpdate(updatedProducts, e.target.checked, product, item);
      }

      if (isChecked) {
        if (!updatedCheckedIds.includes(item.id)) {
          updatedCheckedIds.push(item.id);
        }
      } else {
        updatedCheckedIds = updatedCheckedIds.filter((id) => id !== item.id);
      }
    });

    setLocalSelectedProducts(updatedProducts);
    setCheckedIds(updatedCheckedIds);

    setCurrentVariantIds((prev) => (isChecked ? [...new Set([...prev, ...ids])] : prev.filter((id) => !ids.includes(id))));
  };

  const variantOnChange = (e, product, variant) => {
    const checked = e.target.checked;
    if (variant.price <= 0) {
      return;
    }
    let updatedProducts = [...localSelectedProducts];
    updatedProducts = productObjectUpdate(updatedProducts, e.target.checked, product, variant);
    setLocalSelectedProducts(updatedProducts);

    setCurrentVariantIds((prev) => (checked ? [...new Set([...prev, variant.id])] : prev.filter((id) => id !== variant.id)));
  };

  const productObjectUpdate = (orderProducts, isCheck, product, variant, updateCheckedIds = true) => {
    let orderedProductIndex = orderProducts.findIndex((x) => x.variant === variant.id);
    if (orderedProductIndex != -1) {
      if (!isCheck) {
        orderProducts.splice(orderedProductIndex, 1);
      }
    } else {
      orderProducts.push({
        id: null,
        variant: variant.id,
        product_name: product.name,
        product: product.id,
        image: product.url,
        price: variant.price,
        sku: variant.sku,
        variant_name: variant.variant_name,
        quantity: 1,
        total_price: variant.price,
        current_stock: variant.current_stock,
        format_stock: variant.format_stock,
        sale_price: variant.sale_price,
        rrp: variant.price,
        cost_price: variant.cost_price,
      });
    }

    if (updateCheckedIds) {
      setCheckedIds((prev) => (isCheck ? [...new Set([...prev, variant.id])] : prev.filter((id) => id !== variant.id)));
    }

    return orderProducts;
  };

  const fetchProductData = () => {
    productSearchFunction(true, partnerPromotionState.products.pagination.next_page);
  };

  const isCheckedProduct = (variants) => {
    let avaliableItemsCount = 0;
    let checkedItemsCount = 0;
    variants.map((item, i) => {
      if (item.price > 0) {
        avaliableItemsCount++;
        let orderedProductIndex = localSelectedProducts.findIndex((x) => x.variant === item.id);
        if (orderedProductIndex !== -1) {
          checkedItemsCount++;
        }
      }
    });

    return avaliableItemsCount > 0 && avaliableItemsCount === checkedItemsCount;
  };

  // const isCheckedItem = (item) => {
  //   let orderedProductIndex = localSelectedProducts.findIndex((x) => x.variant === item.id);
  //   return orderedProductIndex !== -1;
  // };

  const isCheckedItem = (item) => currentVariantIds.includes(item.id);

  return (
    <Fragment>
      <div className="form-row mb-3">
        <Modal
          size="lg"
          {...partnerPromotionState.searchProductDialogProps.props}
          toggle={() => {
            closDialog();
          }}
        >
          <ModalHeader
            toggle={() => {
              closDialog();
            }}
          >
            All Products
          </ModalHeader>
          <ModalBody>
            <Row style={{ marginBottom: "1rem" }}>
              <Col>
                <Select
                  placeholder={<div>Collection</div>}
                  className="select2-filter"
                  isClearable
                  cacheOptions
                  //   styles={customStyles}
                  options={filteredCollectionOptions}
                  onChange={(e) => {
                    setCollection(e ? e.value : null);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              </Col>
              <Col>
                <AsyncSelect
                  className="select2-filter"
                  isClearable={true}
                  cacheOptions
                  defaultOptions
                  isMulti
                  placeholder="Tags"
                  loadOptions={partnersPromiseOption}
                  styles={{
                    // ...customStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 100 }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  onClear={(e) => {}}
                  onChange={(e) => {
                    setTags(e);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={3}>
                <FormGroup check inline>
                  <Input
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      selectAllClickRef.current = true;

                      if (!checked) {
                        // ✅ user turned Select All OFF
                        const idsToRemove = selectAllIdsByFilter?.[filterKey] || [];

                        // remove ONLY those ids from global selection
                        setCurrentVariantIds((prev) => prev.filter((id) => !idsToRemove.includes(id)));
                        setCheckedIds((prev) => prev.filter((id) => !idsToRemove.includes(id)));

                        // optional: clear stored select all for this filter
                        dispatch(removeSelectAllForFilter({ filterKey }));
                      }

                      setSelectAll(checked);
                      dispatch(setIsAllActive(checked));
                    }}
                  />
                  <Label check>Select All</Label>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup check inline>
                  <Input type="checkbox" checked={isIncludeSaleItem} onChange={(e) => setIsIncludeSaleItem(e.target.checked)} />
                  <Label check>Include Sale Items</Label>
                </FormGroup>
              </Col>
              <Col sm={12} style={{ marginTop: "1rem" }}>
                <Form style={{ position: "relative" }}>
                  <FormGroup className="m-0">
                    <Input
                      type="text"
                      value={searchTerm}
                      className="form-control"
                      onChange={(e) => {
                        setSearchTerm(e.target.value ? e.target.value : "");
                      }}
                      placeholder="Search Product"
                    />
                    <i className="fa fa-search" style={{ position: "absolute", top: "30%", fontSize: "16px", right: "30px", color: "#898989" }}></i>
                  </FormGroup>
                </Form>
              </Col>
            </Row>
            {loading ? (
              <Card style={{marginTop:"8rem"}}>
                <PreLoader />
              </Card>
            ) : (
              <div className="form-row mb-3 mt-1" style={{ maxHeight: 300, overflowY: "hidden" }}>
                <InfiniteScroll
                  ref={(scroll) => {
                    infiniteScrollRef.current = scroll;
                  }}
                  dataLength={productData.length}
                  next={fetchProductData}
                  hasMore={partnerPromotionState.products.pagination.has_more}
                  refreshFunction={() => {
                    alert("Test");
                  }}
                  pullDownToRefresh={true}
                  // onScroll={(e)=>{console.log(e)}}
                  height={300}
                  loader={<p>Loading...</p>}
                >
                  <table className="table" style={{ width: "100%", height: 300, overflowY: "scroll" }}>
                    <tbody>
                      {productData.map((item, i) => (
                        <Fragment key={i}>
                          <tr>
                            <td style={{ width: "5%", height: 1 }}>
                              <input
                                type={"checkbox"}
                                checked={isCheckedProduct(item.variants)}
                                onChange={(e) => {
                                  productOnChange(e, item, item.variants);
                                }}
                              />
                            </td>
                            <td style={{ width: "15%", textAlign: "center" }}>
                              <img width={20} src={item.url} />
                            </td>
                            <td style={{ textAlign: "left" }}>{item.name}</td>
                          </tr>
                          <tr>
                            <td
                              colSpan={3}
                              style={{
                                paddingTop: 0,
                                paddingRight: 25,
                                paddingLeft: 25,
                                border: "none",
                              }}
                            >
                              <table className="table" style={{ width: "100%", marginTop: 0 }}>
                                <tbody>
                                  {item.variants.map((itemVariant, v) => (
                                    <tr key={v}>
                                      <td style={{ width: "5%" }}>
                                        <input
                                          ref={(ref) => {
                                            variantRef.current[itemVariant.id] = ref;
                                          }}
                                          disabled={itemVariant.price <= 0}
                                          checked={isCheckedItem(itemVariant)}
                                          type={"checkbox"}
                                          onChange={(e) => {
                                            variantOnChange(e, item, itemVariant);
                                          }}
                                        />
                                      </td>

                                      <td
                                        style={{
                                          width: "50%",
                                          textAlign: "left",
                                        }}
                                      >
                                        {itemVariant.variant_name}
                                      </td>

                                      <td style={{ textAlign: "right" }}>{itemVariant.format_stock}</td>
                                      <td style={{ textAlign: "right" }}>£ {itemVariant.price}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </Fragment>
                      ))}
                    </tbody>
                  </table>
                </InfiniteScroll>
              </div>
            )}
          </ModalBody>

          <ModalFooter>
            <Row>
              <Col sm="12">
                <div className="float-sm-right ">
                  <button
                    onClick={() => {
                      setSelectedProducts();
                    }}
                    className="btn  btn-primary"
                  >
                    {" "}
                    {isProductUpdate ? (
                      <>
                        <i className="fa fa-spinner spinner mr-1" /> Adding..
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    </Fragment>
  );
};

function areEqual(prevProps, nextProps) {
  return JSON.stringify(prevProps.getValues) == JSON.stringify(nextProps.getValues);
  /*
    return true if passing nextProps to render would return
    the same result as passing prevProps to render,
    otherwise return false
    */
}

export default React.memo(PartnerProductsSearchModalWindow, areEqual);
